(function() {
  'use strict';

  var HOURS = 'Monday-Thursday: 9:00 AM - 5:00 PM CT | Friday: 9:00 AM - 3:00 PM CT | Saturday-Sunday: Closed';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function policyShell(title, eyebrow, bodyHtml) {
    return [
      '<section class="section" style="padding:var(--space-3xl) 0;">',
      '<div class="container" style="max-width:900px;">',
      '<p class="section-label">' + eyebrow + '</p>',
      '<h1 style="font-family:var(--font-display);font-size:clamp(2.2rem,5vw,4rem);margin-bottom:16px;">' + title + '</h1>',
      '<div style="display:grid;gap:22px;color:var(--color-light-gray);line-height:1.8;">',
      bodyHtml,
      '</div>',
      '</div>',
      '</section>'
    ].join('');
  }

  function replacePolicyPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    var main = document.getElementById('main-content') || document.querySelector('main');
    if (!main) return;

    if (path === '/policies/shipping-policy') {
      document.title = 'Shipping Policy - Low Key Automotive';
      main.innerHTML = policyShell('Shipping Policy', 'Low Key Automotive', [
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Order Processing</h2>',
        '<p>We work to process in-stock orders quickly during business hours. Most in-stock parts ship as soon as the order is verified and fulfilled, but processing time can vary by item, warehouse, carrier pickup, oversized freight, and payment review.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Shipping Rates And Carriers</h2>',
        '<p>Shipping rates are shown at checkout when available. Orders may ship by UPS, FedEx, USPS, LTL freight, manufacturer direct shipment, or another available carrier depending on size, weight, destination, and supplier availability.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Tracking</h2>',
        '<p>When tracking is available, it will be sent to the email or phone number used at checkout. Some freight, special-order, or supplier-direct shipments may update on a different timeline.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Freight And Oversized Parts</h2>',
        '<p>Large or heavy parts may require freight delivery, a commercial address, liftgate service, or additional confirmation before shipment. We will contact you if extra information is needed.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Damaged Shipments</h2>',
        '<p>Inspect packages when they arrive. If an item is damaged in transit, contact us right away with your order number and photos of the packaging and product so we can help document the claim.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Need Help?</h2>',
        '<p>Call <a href="tel:8065442520" style="color:var(--color-accent);">(806) 544-2520</a> or <a href="/pages/contact" style="color:var(--color-accent);">contact Low Key Automotive</a> with shipping or fitment questions before ordering.</p></div>'
      ].join(''));
    }

    if (path === '/policies/terms-of-service') {
      document.title = 'Terms of Service - Low Key Automotive';
      main.innerHTML = policyShell('Terms of Service', 'Low Key Automotive', [
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Orders And Fitment</h2>',
        '<p>Customers are responsible for choosing parts that match their truck, use case, and local requirements. We provide fitment support when you send your VIN, vehicle details, or product questions before ordering.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Shipping, Returns, And Refunds</h2>',
        '<p>Shipping, return eligibility, refund timing, and non-returnable item rules are covered in our <a href="/policies/shipping-policy" style="color:var(--color-accent);">Shipping Policy</a> and <a href="/policies/refund-policy" style="color:var(--color-accent);">Refund Policy</a>.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Privacy</h2>',
        '<p>Information collected through our website, checkout, contact forms, and Shopify services is handled according to our <a href="/policies/privacy-policy" style="color:var(--color-accent);">Privacy Policy</a>.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Governing Law</h2>',
        '<p>These terms are governed by the laws of the State of Texas. Where permitted by law, disputes will be handled in the state or federal courts serving Terry County, Texas and the Brownfield, Texas area.</p></div>',
        '<div><h2 style="font-family:var(--font-condensed);font-size:1.2rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-white);margin-bottom:8px;">Contact</h2>',
        '<p>Low Key Automotive, 2328 Lubbock Road, Brownfield, TX 79316. Phone: <a href="tel:8065442520" style="color:var(--color-accent);">(806) 544-2520</a>.</p></div>'
      ].join(''));
    }
  }

  function cleanText(text) {
    return text
      .replace(/\bPowerstroke\b/g, 'Power Stroke')
      .replace(/\bpowerstroke\b/g, 'Power Stroke')
      .replace(/\bPOWERSTROKE\b/g, 'POWER STROKE')
      .replace(/\bL5O\b/g, 'L5P')
      .replace(/\bFitment Guarantee\b/g, 'Fitment Support')
      .replace(/\bfitment guarantee\b/g, 'fitment support')
      .replace(/\bEasy Returns\b/g, 'Eligible Returns')
      .replace(/return any unused part within 30 days, hassle-free/gi, '30-day returns on eligible unused parts')
      .replace(/Mon-Thu\s*9am\s*[-–]\s*5pm\s*CT\s*\|\s*Fri\s*9am\s*[-–]\s*3pm\s*CT\s*\|\s*Sat-Sun\s*closed/gi, HOURS)
      .replace(/Mon-Fri[: ]+\s*8am\s*[-–]\s*6pm(?:\s*\|\s*Sat[: ]+\s*9am\s*[-–]\s*4pm)?/gi, HOURS)
      .replace(/Monday\s*[-–]\s*Friday[: ]+\s*8:00 AM\s*[-–]\s*6:00 PM/gi, 'Monday-Thursday: 9:00 AM - 5:00 PM')
      .replace(/Saturday[: ]+\s*9:00 AM\s*[-–]\s*4:00 PM/gi, 'Saturday-Sunday: Closed');
  }

  function normalizeVisibleText(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (/^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        if (!node.nodeValue || !/(Powerstroke|powerstroke|POWERSTROKE|L5O|Fitment Guarantee|fitment guarantee|Easy Returns|hassle-free|8am|8:00 AM|9:00 AM)/.test(node.nodeValue)) {
          return NodeFilter.FILTER_SKIP;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node) {
      node.nodeValue = cleanText(node.nodeValue);
    });
  }

  function hidePlaceholderBlocks() {
    document.querySelectorAll('section, [data-tab*="review"], [data-tab-panel*="review"], [id*="review"], .product-reviews, .reviews-section, .testimonial-section').forEach(function(el) {
      var text = el.textContent || '';
      if (/reviews will display|judge\.me|yotpo|shopify product reviews|review app/i.test(text)) {
        el.hidden = true;
      }
      if (/(Jake T|Marcus L|Sarah K)/.test(text) && /(What Our Customers Say|Straight From|testimonial|review)/i.test(text)) {
        el.hidden = true;
      }
    });
  }

  ready(function() {
    replacePolicyPage();
    normalizeVisibleText(document.body);
    hidePlaceholderBlocks();

    if (window.MutationObserver) {
      var timer;
      var observer = new MutationObserver(function() {
        window.clearTimeout(timer);
        timer = window.setTimeout(function() {
          normalizeVisibleText(document.body);
          hidePlaceholderBlocks();
        }, 80);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
